import React from "react";

import AppRouteGenerator from "components/Common/AppRouteGenerator";
import { AirbyteProvider } from "contexts/airbyte";

import ArchivalReports from "./ArchivalReports";
// import DelimitedData from "./DelimitedData";
import NestedPDFSearch from "./NestedPDFSearch";
import SourceDatabases from "./SourceDatabases";
import UploadFromLocal from "./UploadFromLocal";

const DataIngestion = ({ features }) => {
  const CLIENT_ROUTES = {
    Connections: {
      component: SourceDatabases,
      path: "source-databases",
    },
    "Archival Documents": {
      component: ArchivalReports,
      path: "archival-reports",
    },
    "Advanced PDF Search": {
      component: NestedPDFSearch,
      path: "nested-pdf-search",
    },
    "Upload From Local": {
      component: UploadFromLocal,
      path: "upload-from-local",
    },
  };

  return (
    <AirbyteProvider>
      <AppRouteGenerator CLIENT_ROUTES={CLIENT_ROUTES} features={features} />
    </AirbyteProvider>
  );
};

export default DataIngestion;
